module.exports = __webpack_public_path__ + "img/less-than-equal.1bb0d0fa.svg";